import React, { useState } from "react";
import Button from "./Button";
import Icon from "../../../assets/icons/Icon";
import Error from "./Error";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { hashedPassword } from "../../helper/common";
import {
  API_GET_MARKET_OPERATION,
  API_POST_MARKET_OPERATION_RUNNERS,
} from "../../../utils/api/ApiConstant";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getAxios, postAxios } from "../../Services/commonService";

const confirmationSchema = Yup.object({
  password: Yup.string().trim().required("Password is required"),
});

const Confirmation = ({
  rowData,
  onConfirm,
  onCancel,
  title = "",
  description = "",
  confirmText = "Submit",
  isConfirmed = false,
  handleShowHide,
}) => {
  const [showHide, setShowHide] = useState(false);
  const [runnerId, setRunnerId] = useState(null);
  const [resultValue, setResultValue] = useState(null);
  const { isLoading } = useSelector((state) => state.ui);

  const marketId = rowData?.marketId ?? rowData?.Id;
  const marketType = rowData?.marketType;
  const eventName = rowData?.eventName;
  const ignoreRunners = rowData?.ignoreRunners;
  console.log("rowData", rowData);
  console.log("marketId", marketId);
  console.log("runnerId", runnerId);

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      result: "",
    },
    resolver: yupResolver(confirmationSchema),
    mode: "onTouched",
  });

  const { data: openMarketData = [] } = useQuery({
    queryKey: ["openMarketData", marketId],
    queryFn: () => getAxios(`${API_GET_MARKET_OPERATION}/${marketId}`),
    enabled: !!marketId,
  });

  console.log("openMarketData", openMarketData);

  const { mutate: submitRunnerResult, isPending } = useMutation({
    mutationFn: (payload) =>
      postAxios(`${API_POST_MARKET_OPERATION_RUNNERS}/${marketId}`, payload),
    onSuccess: (response) => {
      console.log("response", response);
      handleShowHide?.();
      onCancel?.();
    },
    onError: (error) => {
      console.log("error", error);
    },
  });

  const onSubmit = ({ password, result }) => {
    const storedHash = localStorage.getItem("cipherMark");
    const finalHash = hashedPassword(password);

    console.log("storedHash", storedHash);
    console.log("finalHash", finalHash);

    if (!storedHash || storedHash !== finalHash) {
      setError("password", {
        type: "manual",
        message: "Incorrect password",
      });
      return;
    }

    clearErrors("password");

    if (isConfirmed) {
      onConfirm?.();
      return;
    }

    if (openMarketData.length > 0) {
      if (!runnerId) {
        setError("result", {
          type: "manual",
          message: "Please select a team",
        });
        return;
      }

      clearErrors("result");

      const runnerPayload = {
        runnerId,
        result: null,
      };
      console.log("runnerPayload", runnerPayload);
      submitRunnerResult(runnerPayload);
      return;
    }

    if (!result && !rowData?.label) {
      setError("result", {
        type: "manual",
        message: "Result is required",
      });
      return;
    }

    clearErrors("result");

    const resultPayload = {
      runnerId: null,
      result: rowData?.label || result,
    };
    console.log("resultPayload", resultPayload);
    submitRunnerResult(resultPayload);
  };

  const renderPasswordField = () => (
    <div className="form-group">
      <label className="form-label" htmlFor="password">
        Password
      </label>
      <div className="password-field">
        <input
          type={showHide ? "text" : "password"}
          className="form-control"
          id="password"
          placeholder="Enter password"
          {...register("password")}
        />
        <button
          type="button"
          className="password-toggle"
          onClick={() => setShowHide((prev) => !prev)}
          aria-label={showHide ? "Hide password" : "Show password"}
        >
          {showHide ? <Icon name="EyeClosed" /> : <Icon name="Eye" />}
        </button>
      </div>
      {errors.password && <Error>{errors.password.message}</Error>}
    </div>
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {isConfirmed ? (
        <div className="section_main">
          <div className="header_text">
            <h3>{title}</h3>
            <p>{description}</p>
          </div>

          {renderPasswordField()}

          <div className="actions-grape split">
            {onCancel && (
              <Button
                type="button"
                className="btn btn_main btn_muted w-100 justify-content-center"
                onClick={onCancel}
              >
                Cancel
              </Button>
            )}
            <Button
              type="submit"
              className="btn btn_main w-100 justify-content-center"
              disabled={isLoading || isPending}
            >
              {isLoading || isPending ? "Loading..." : confirmText}
            </Button>
          </div>
        </div>
      ) : (
        <div className="section_main">
          <div className="header_text ">
            <h3>{title || "Settlement Confirmation"}</h3>
            <p> Review the market details and complete the action securely.</p>
          </div>

          <div className="name_box">
            <div className="meta-item">
              <span>Type</span>
              <strong>{marketType || "-"}</strong>
            </div>
            <div className="meta-item">
              <span>Match Name</span>
              <strong>{eventName || "-"}</strong>
            </div>
          </div>

          {!ignoreRunners ? (
            <div className="content_box">
              <label className="form-label">Select the team</label>
              <div className="select_label">
                {openMarketData &&
                  openMarketData.map((marketData, index) => (
                    <div
                      className=" form-check settlement-option"
                      key={index}
                      htmlFor={`runner-${index}`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        value={marketData?.runnerName}
                        onChange={() => setRunnerId(marketData?.runnerId)}
                        id={`runner-${index}`}
                        name="runner"
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`runner-${index}`}
                      >
                        {marketData?.runnerName}
                      </label>
                    </div>
                  ))}
                {errors.result && <Error>{errors.result.message}</Error>}
              </div>
              {renderPasswordField()}

              <div className="actions-grape">
                <Button
                  type="submit"
                  className="btn btn_main w-100 justify-content-center"
                  disabled={isLoading || isPending}
                >
                  {isLoading || isPending ? "Loading..." : "Submit"}
                </Button>
              </div>
            </div>
          ) : openMarketData?.length === 0 && !ignoreRunners ? (
            <div className="content_box">
              <p className="text-center">No data found</p>
            </div>
          ) : (
            <div className="content_box">
              <div className="form-group">
                <label className="form-label" htmlFor="result">
                  Result
                </label>
                <input
                  onChange={(e) => setResultValue(e.target.value)}
                  min="0"
                  step="any"
                  type="number"
                  className="form-control"
                  id="result"
                  placeholder="Enter result"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "+" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  {...register("result")}
                />
              </div>

              {errors.result && <Error>{errors.result.message}</Error>}

              {renderPasswordField()}

              <div className="actions-grape">
                <Button
                  type="submit"
                  className="btn btn_main w-100 justify-content-center"
                  disabled={isLoading || isPending}
                >
                  {isLoading || isPending ? "Loading..." : "Submit"}
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </form>
  );
};

export default Confirmation;
